import { createSelector } from 'reselect';
import { descend, filter, prop as rProp, slice, sortWith } from 'ramda';

import { createFilter } from './FilterUtil';

const getCompanies = state => state.entities.companies.items;
const getCompaniesFilter = state => state.entities.companies.filter;
const getCompaniesPagination = state => state.entities.companies.pagination;

const companyMatchesFilter = (c, filter) =>
  !filter ||
  c.name.indexOf(filter) > -1 ||
  c.slug.indexOf(filter) > -1 ||
  (c.contractPlan && c.contractPlan.type && c.contractPlan.type.indexOf(filter) > -1);

export const getCompaniesFiltered = createSelector(
  [getCompanies, getCompaniesFilter],
  (companies, filterValue) =>
    filterValue ? filter(createFilter(filterValue, companyMatchesFilter), companies) : companies
);

export const getCompaniesFilteredPage = createSelector(
  [getCompaniesFiltered, getCompaniesPagination],
  (filtered, { page, size }) => {
    const sorted = sortWith([descend(rProp('createdAt')), descend(rProp('id'))], filtered);
    return {
      items: slice(page * size, (page + 1) * size, sorted),
      page: page,
      size: size,
      totalSize: sorted.length
    };
  }
);



// WEBPACK FOOTER //
// ./src/selectors/CompaniesSelector.js